<!-- Permissions -->
<div [appEnforcePermission]="authConfig.investigationDocumentsUpdate"
  #investigationDocumentsUpdate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.investigationReportsUpdate" #investigationReportsUpdate="appEnforcePermission">
</div>
<div [appEnforcePermission]="authConfig.investigationCommentsCreate"
  #investigationCommentsCreate="appEnforcePermission"></div>
<!-- Permissions -->
<section>
  <div class="page-filters">
    <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }" [cols]="['repeat(5,minmax(0,1fr))']">
      <kendo-gridlayout-item>
        <div class="kendo-formfield left-search-icon">
          <kendo-label [for]="search" text="Search"></kendo-label>
          <div style="position: relative;">
            <i class="fa fa-search" aria-hidden="true"></i>
            <kendo-textbox #search [(ngModel)]="searchValue" (valueChange)="setFilters($event, filterTypes.Search)"
              (keydown.enter)="filterTable()" placeholder="Search" fillMode="outline" [clearButton]="false"
              [value]="filterValue(filterTypes.Search || null)">
            </kendo-textbox>
          </div>
        </div>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item>
        <app-user-select-kendo [userViewFilter]="userViewFilter" [userId]="filterValue(filterTypes.User)" label="Search"
          placeholder="Search by staff member" [includeInactive]="false"
          (selectionChanged)="setFilters($event?.id, filterTypes.User)" (enteredPressed)="filterTable()">
        </app-user-select-kendo>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-document-type-multi-select-kendo label="Report Type" placeholder="Select Report Type"
          [selectedId]="filterByIdValue(filterTypes.TypeIdIn)" (enteredPressed)="filterTable()"
          (selectionChanged)="setFilters($event, filterTypes.TypeIdIn)"></app-document-type-multi-select-kendo>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="filter-actions" [colSpan]="2" [col]="0" [row]="0">
        <div class="applied-filter mr-16">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="filterTable()">Apply
              Filters</kendo-button>
          </div>
        </div>
        <div class="clear-filter mt-5">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearFilter()">Clear
              All</kendo-button>
          </div>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>
</section>
<section>
  <kendo-grid class="pending-request" [data]="{
      data: tableData,
      total: (dataSource?.pageInfo$ | async)?.totalCount
    }" [pageSize]="pageOptions?.limit" [skip]="pageOptions?.offset" [pageable]="{
      buttonCount: 6,
      type: 'numeric',
      pageSizes: [5, 10, 25, 100],
      previousNext: true,
      responsive: true,
      position: 'bottom'
    }" (pageChange)="pageChange($event)" [sortable]="true" [sort]="sort" (sortChange)="sortChange($event)"
    [navigatable]="false">
    <kendo-grid-column *ngIf="config.type === types.EditorReview" field="STATUS" title="#" [width]="5" class="id-column" [sortable]="true" [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div kendoTooltip position="right" title="Client Review" tooltipClass="tooltipwidthauto" *ngIf="dataItem?.Status?.status === types.ClientReview">
          <i class="fa-solid fa-user-tie"></i>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="CREATED_AT" title="Investigation" [width]="24" [sortable]="true"
      [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem?.Investigation" [type]="'investigation'">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="Details" [title]="config.type === types.TechReview ? 'Client' : 'Bill To'" [width]="24" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="config.type === types.TechReview; else billToDetails">
          <span class="text-overflow" *ngIf="dataItem?.Investigation?.Client">
            <app-client-info-popover [id]="dataItem?.Investigation?.id"
              [client]="dataItem.Investigation.Client"></app-client-info-popover>
            <br /></span>
          <span class="text-overflow" *ngIf="dataItem?.Investigation?.ClientBranch?.Company?.name">{{
            dataItem?.Investigation?.ClientBranch?.Company?.name }} </span>
        </ng-container>
        <ng-template #billToDetails>
          <span class="text-overflow" *ngIf="dataItem?.Investigation?.BillTo">
            <app-bill-to-info-popover [id]="dataItem?.Investigation?.id"
              [billTo]="dataItem.Investigation.BillTo"></app-bill-to-info-popover><br /></span>
          <span class="text-overflow" *ngIf="dataItem?.Investigation?.BillToBranch?.Company?.name">{{
            dataItem?.Investigation?.BillToBranch?.Company?.name }}</span>
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="PRIORITY" title="Priority" [width]="10" [sortable]="true" [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem?.Investigation" [type]="'priority'">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="SUBMITTED_AT" title="Report" [width]="20" [sortable]="true" [headerClass]="'sort-header'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="link text-overflow" (click)="openInOffice365(dataItem)" [innerHTML]="dataItem?.Type?.name"></span>
        <br />
        <span class="text-overflow">{{ dataItem?.CreatedBy | fullName }}</span>
        <br />
        <span *ngIf="dataItem?.Status?.createdAt">{{ dataItem?.Status?.createdAt | customDate : 'MM/dd/yyyy' }}</span>
        <span *ngIf="!dataItem?.Status?.createdAt">-</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="EDITOR" title="Assigned" [width]="20" [sortable]="false" [headerClass]="'nocursor'"
      *ngIf="config.type === types.EditorReview || config.type === types.TechReview">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="config.type === types.TechReview">
          <div class="merged-column-cell assigned-cell">
            <div class="assigned-row"
              *ngFor="let staff of dataItem?.Investigation?.InvestigationStaff | investigationStaffRole : investigationRoleNames.TechReviewer : true">
              <span class="assigned-name">{{ staff | fullName }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="config.type === types.EditorReview">
          <span *ngIf="dataItem?.Editor" class="text-overflow">{{ dataItem?.Editor | fullName }}</span>
          <span *ngIf="!dataItem?.Editor">-</span>
        </ng-container>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="investigationIcons" title="Current"
      [width]="config.type === types.ReadyForEditor ? 25 : 30" [sortable]="false"
      [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-investigation-table-common-columns [dataItem]="dataItem?.Investigation" [type]="'current'"
          [investigationCommentsCreateEnabled]="investigationCommentsCreate?.enabled"
          (commentAdd)="addComment($event)"
          (documentsReportsOpen)="goToInvestigationDocumentsReports($event.event, $event.investigation)">
        </app-investigation-table-common-columns>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="Action" title="Action"
      [width]="config.type === types.ReadyForEditor ? 15 : 10" [sortable]="false" [headerClass]="'nocursor'">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="config.type === types.ReadyForEditor">
          <button kendoButton themeColor="primary" fillMode="link" (click)="assignToMe(dataItem);"
            *ngIf="investigationDocumentsUpdate?.enabled && investigationReportsUpdate?.enabled">Assign to me</button>
        </ng-container>
        <button kendoButton class="mr-8" themeColor="primary" fillMode="link" iconClass="fa-solid fa-copy"
          *ngIf="config.type === types.ReadyForEditor || config.type === types.EditorReview || config.type === types.TechReview"
          (click)="copyToClipboard(dataItem?.Investigation)"></button>
        <kendo-dropdownbutton [data]="getActionItems(dataItem)" themeColor="primary" fillMode="link"
          buttonClass="grid-action-items" iconClass="fa-solid fa-ellipsis" (itemClick)="itemSelected($event, dataItem)"
          [popupSettings]="{
            appendTo: 'component',
            animate: false,
            width: 250,
            popupClass: 'grid-action-items-menu'
          }">
        </kendo-dropdownbutton>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</section>
